var ajaxCalls = require('./ajaxCalls');
var examFrame = require('./exam_parts/exam_frame');
var QuestionController = require('./question_controller');
var sprintf = require('sprintf-js').sprintf;
var drawstars = require('./drawstars');
var timerLoop = require('./timerloop');
var list = require('./list');
var setGuessed = require('./setguessed');
var save = require('./save');
var finish = require('./finish');
var checkProgress = require('./checkprogress');
var report = require('./report');

var _global = {};

function Exam(container,userId, examId, apiUrl,imageHost,modal,dashboardLink, examReviewLink) {

    var question = {};
    var exam = examFrame(question,examId);
    _global = { container:container, userId:userId, exam: exam, examId : examId, apiUrl: apiUrl, imageHost: imageHost, modal:modal, dashboardLink: dashboardLink, examReviewLink:examReviewLink };
    $(container).append(exam);

    ajaxCalls.getExam(userId,examId,apiUrl,function(response) {
        $(exam).find('.exam-name .name').html(response.name);
        var answers = response.answers;

        // console.log(response);

        _global.response = response;
        _global.questionIndex=0;

        // recover the last session and advance the questions
        if (response.current_question_position) {
            _global.questionIndex=response.current_question_position;
        }

        // set the first question
        QuestionController.setQuestion(exam,_global,imageHost);
        checkProgress( _global);

        // start the timer
        _global.elapsedTime = response.elapsed_time;
        _global.ping = 10;
        var timer = setInterval(function(){
            _global.timer = timer;
            timerLoop(exam,_global);
        },1000);



        // Attach actions to buttons
        // Stars
        $(exam).find('.stars .star').on('mouseover',function() {
            var thisStar = this;
            var stop = false;
            $(exam).find('.stars .star').each(function() {
                if (stop === false ) {
                    $(this).addClass('highlight');
                    if (this === thisStar) {
                        stop = true;
                    }
                } else {
                    $(this).removeClass('highlight');
                }
            });
        });

        $(exam).find('.stars').on('mouseout',function() {
            // restore
            drawstars(exam,_global);
        })

        $(exam).find('.stars .star').click(function() {
            var currentQuestion = _global.response.answers[_global.questionIndex];
            currentQuestion.rating = $(this).attr('data');
        });


        // previous and next buttons
        $(exam).find('button.previous').click(function() {
            if (_global.questionIndex > 0 ) {

                // update the answer
                var answer = _global.response.answers[_global.questionIndex];
                ajaxCalls.updateAnswer(_global.userId,_global.examId,answer);

                _global.questionIndex--;
                QuestionController.setQuestion(exam,_global,imageHost);
            }
        });

        $(exam).find('button.next').click(function() {
            if (_global.questionIndex < answers.length ) {
                // no answer? set it to skipped.
                if ($('.list-group input[name=answer]:checked').length == 0) {
                    _global.response.answers[_global.questionIndex].status = 'skipped';
                } else {
                    _global.response.answers[_global.questionIndex].status = 'seen';
                }

                // update the answer
                var answer = _global.response.answers[_global.questionIndex];
                ajaxCalls.updateAnswer(_global.userId,_global.examId,answer);

                _global.questionIndex++;
                QuestionController.setQuestion(exam,_global,imageHost);
            }
        });

        $(exam).find('#list').click(function() {
            list(exam,_global);
        })

        // guessed checkbox
        $(exam).find('#guessed').click(function() {
            setGuessed(this,_global);
        })

        // Save button
        $('#save').click(function() {
            // force a ping in order to save the current question position
            ajaxCalls.ping(_global.userId,_global.examId,_global.elapsedTime,_global.questionIndex,_global.apiUrl);
            save(exam,_global);
        });
        // Finish button
        $('#finish').click(function() {
            finish(exam,_global);
        });
        // Report Button
        $('#report').click(function() {
            report(exam,_global);
        })
    })




}



module.exports = Exam;








//////////////////
// WEBPACK FOOTER
// ./src/Exam.js
// module id = 313
// module chunks = 0